<template>
  <div>
  <div class="container-fluid">
            <div class="success_message" v-text="this.$root.success_message" v-if="this.$root.success_message != ''"></div>
            <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div>
            <div class="row">
                <div class="col-12">
                <div class="content-pages">
                <h2 class="page-title">Sitemap</h2>
                    <div class="sitemap-p">
                    <div class="row">
                    <div class="sitemap-inner col-md-6 col-12">
                      <h4><a href="/">Home</a></h4>
                    </div>

<div class="sitemap-inner col-md-6 col-12" v-for="item in this.$root.menu">
        <h4><router-link v-ripple :to="{path:item.menu_url_key+'.html', name:item.menu_url_key, params:{ cat_id: item.id_category, store_id: '1' , menu_url_key:item.menu_url_key}}" :key="item.id_category" v-text="item.name"></router-link></h4>
         <ul v-if="item.childs">
          <li  v-for="option in item.childs">
            <router-link v-ripple :to="{path:option.menu_url_key+'.html', name:option.menu_url_key, params: { cat_id:option.id_category, store_id:'1' , menu_url_key:option.menu_url_key}}" :key="option.id_category"  v-text="option.name"></router-link>
          </li>
          </ul>
</div>
<div class="sitemap-inner col-md-6 col-12">
<h4><a href="#">Help & Support</a></h4>
 <ul>
      <li><router-link :to="{name:'support'}">Support</router-link></li>
      <li><router-link :to="{name:'company'}">Company</router-link></li>
      <li><a href="https://wforwoman.com/content/investor-relation/">Investor Relation</a></li>
      <li><router-link :to="{name:'privacy_policy'}">Privacy Policy</router-link></li>
      <li><router-link :to="{name:'contact_us'}">Contact Us</router-link></li>
      <li><router-link :to="{name:'fashion_awards'}">Fashion Awards</router-link></li>
      <li><router-link :to="{name:'sitemap'}">Sitemap</router-link></li>
      <li v-if="this.$root.store === 1"><a href="/content">Blog</a></li>
      <li v-if="this.$root.store === 2"><a href="/blog">Blog</a></li>
  </ul>
</div>
</div>
</div>
                </div>
                 </div>
        </div>
        </div>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'sitemap',
  metaInfo () {
      return {
          title:this.meta_title,
          meta: [
          {
              name: 'description',
              content: this.meta_description
          },
          {
              property: 'keywords',
              content: this.meta_keyword
          }
          ]
      }
  },
  data() {
        return {
            meta_title:'',
            meta_description:'',
            meta_keyword:'',
        };
    },
    created () {
        window.scrollTo(0, 0);
        this.$root.breadcrumb = 'Sitemap';
        if(this.$root.store === 1){
            this.meta_title = 'Sitemap W';
            this.meta_description = 'Online fashion shopping destination for the modern women. Buy latest collection of online ethnic wear for women, W Kurtas, dresses, bottom wear, tops, palazzos, culottes, skirts, drapes and more.';
            this.meta_keyword = 'Online Shopping for Women,  W for Woman';
        }
        else
        {
           this. meta_title = 'Sitemap Aurelia';
           this.meta_description = 'Shop a wide range of women, online fashionable clothes that suits every occasion - Top wear, Bottom wear, Suit Sets &amp; Dupatta. Free Shipping. COD. 15Day Returns.';
           this.meta_keyword = 'online shopping for women, fashion women clothing, buy womens clothing online, shop women clothing';
        }
    }
}
</script>
